import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface DetailViewProps {
  /** Page title shown in the back-button label: "Back to {title} List" */
  title: string;
  /** Route string or history delta (e.g. -1) */
  backPath: string | number;
  /** Buttons rendered in the top-right header area */
  actions?: React.ReactNode;
  /** Full page body — caller owns all card layout */
  children: React.ReactNode;
}

const DetailView: React.FC<DetailViewProps> = ({
  title,
  backPath,
  actions,
  children,
}) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <button
          onClick={() =>
            typeof backPath === "number" ? navigate(backPath) : navigate(backPath)
          }
          className="flex shrink-0 items-center gap-2 text-sm text-gray-500 transition-colors hover:text-gray-900"
        >
          <ArrowLeft size={16} />
          <span>Back to {title} List</span>
        </button>

        {actions && (
          <div className="flex flex-wrap items-center gap-3 sm:justify-end">{actions}</div>
        )}
      </div>

      {children}
    </div>
  );
};

export default DetailView;
